<template>
    <div class="mineitembord" v-bind:class="$store.state.mine_cur == mineItem.nft.get_id() ? 'mseleitem' : ''">
        <div style="align-self: flex-start;justify-self: flex-start;">
            <button @click="close_mine_item(wrkk)">x</button>
        </div>
        <div v-if="mineItem.nft.get_strength() > 26" class="warning" style="text-align: center;">
            you are mining an NFT with a Strength of {{ mineItem.nft.get_strength() }}, you have now entered uncharted
            territories, the browser miner is intended only for kick-starting the
            strengthening of NFTs , further usage of the browser miner is not
            recommended as it will most likely crash your browser. you can try the
            <a style="color:yellow" target="_blank" href="https://github.com/qooboodoop/simple_coal_miner">offline
                miner</a> . dont forget to submit your already found nonces before moving to the offline miner.
        </div>
        <div>Mining of NFT # {{ mineItem.nft.get_id() }}</div>
        <CoalRend :nft="mineItem.nft"></CoalRend>
        <hr style="width: 100%;">
        <div v-show="mineItem.run_state == ENUMS.WORKER.RUNNING">
            <button @click="stop_worker(wrkk)" style="min-width: 100px;">stop</button>
        </div>
        <div v-show="mineItem.run_state == ENUMS.WORKER.STOPPED">
            <button @click="continue_worker(wrkk)" style="min-width: 100px;">continue</button>
        </div>
        <div v-show="mineItem.strongest_nonce_found != undefined" style="text-align: center;">best nonce found so far
            <span>

            </span>
            strengthens from {{
        mineItem.nft.get_strength()
}} ->
            {{ mineItem.strongest_nonce_found_strength }} <span class="smalltex fadednonce">( {{
        mineItem.strongest_nonce_found
}} )</span>
        </div>
        <button class="bestnonc" @click="submit_to_nfr(wrkk)">Submit</button>
        <div v-show="mineItem.run_state == ENUMS.WORKER.RUNNING">
            <div style="text-align: center;"> running ... </div>
            <div>{{ (mineItem.decoy_nonce != undefined) ? mineItem.decoy_nonce : "" }}</div>
        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';
import CoalRend from './CoalRend.vue';

export default {
    name: 'CoalMineItem'
    , components: { CoalRend }
    , data() {
        return {
            ENUMS: ENUMS

        }
    }
    , props: ["mineItem", "wrkk"]
    , computed: {


    }
    , methods: {
        close_mine_item(wrkk) {
            this.$store.state.mine_manager.clean(wrkk)
        }
        , submit_to_nfr: function (wrkk) {
            this.$store.state.nfr_manager.add_nfr(this.$store.state.mine_manager.mine[wrkk])
            this.close_mine_item(wrkk)
        }
        , continue_worker: function (wrkk) {
            this.$store.state.mine_manager.mine[wrkk].continue()

        }
        , stop_worker: function (wrkk) {
            this.$store.state.mine_manager.mine[wrkk].close_mine()
        }

    }
}

</script>

<style scoped>
.bestnonc {
    color: rgb(182, 12, 12);
}

.fadednonce {
    color: rgb(95, 95, 95);
}

.warning {
    color: red;
    animation: warninganim .51s 5 alternate;
}

@keyframes warninganim {
    0% {
        color: red;
    }

    100% {
        color: white;
    }


}
</style>